/* ─── JHN Messages — interface de messagerie ────────────────────────────────── */

.messenger { height: 100%; display: grid; grid-template-columns: 340px 1fr; overflow: hidden; }

/* ── Liste des conversations ── */
.msg-list { display: flex; flex-direction: column; border-right: 1px solid var(--hairline); min-height: 0; }
.msg-list-head { display: flex; align-items: center; gap: 10px; padding: 18px 18px 12px; }
.msg-list-head h2 { font-size: 22px; margin-right: auto; }
.msg-conv-items { flex: 1; overflow: auto; padding: 4px 8px 16px; }
.msg-conv { display: flex; align-items: center; gap: 12px; padding: 10px 12px; border-radius: 14px; cursor: pointer; transition: background var(--dur); }
.msg-conv:hover { background: var(--glass); }
.msg-conv.active { background: var(--glass-strong); }
.msg-conv-main { flex: 1; min-width: 0; }
.msg-conv-top { display: flex; align-items: baseline; gap: 8px; }
.msg-conv-top b { font-size: 15px; font-weight: 600; flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.msg-conv-time { font-size: 12px; color: var(--text-faint); flex: none; }
.msg-conv-bot { display: flex; align-items: center; gap: 8px; margin-top: 2px; }
.msg-conv-prev { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 13.5px; color: var(--text-dim); }
.msg-badge { flex: none; min-width: 20px; height: 20px; padding: 0 6px; border-radius: 99px; background: var(--coral); color: #fff; font-size: 12px; font-weight: 700; display: grid; place-items: center; }

/* ── Fil ── */
.msg-thread { display: flex; flex-direction: column; min-height: 0; min-width: 0; }
.msg-empty-thread { flex: 1; display: grid; place-content: center; justify-items: center; gap: 8px; text-align: center; color: var(--text-dim); }
.msg-empty-thread .ico { width: 72px; height: 72px; border-radius: 22px; display: grid; place-items: center; background: var(--glass); border: 1px solid var(--border); color: var(--text-faint); }
.msg-thread-head { display: flex; align-items: center; gap: 12px; padding: 12px 18px; border-bottom: 1px solid var(--hairline);
  -webkit-backdrop-filter: blur(18px) saturate(170%); backdrop-filter: blur(18px) saturate(170%); background: linear-gradient(180deg, var(--glass-strong), transparent); }
.msg-thread-head b { font-size: 15.5px; }
.msg-sub { font-size: 12.5px; color: var(--text-faint); }
.msg-sub.typing { color: var(--coral); font-style: italic; }
.msg-back { display: none; }

/* Pastille de statut sur la photo de profil (verte=en ligne, rouge=hors ligne) */
.avatar-wrap { position: relative; flex: none; }
.avatar-dot { position: absolute; right: -1px; bottom: -1px; width: 30%; height: 30%;
  min-width: 9px; min-height: 9px; max-width: 14px; max-height: 14px; border-radius: 50%;
  border: 2px solid var(--bg); box-sizing: border-box; }
.avatar-dot.online { background: #34d27b; }
.avatar-dot.offline { background: #e0564f; }

.msg-scroll { flex: 1; overflow: auto; padding: 18px clamp(12px, 6%, 80px); display: flex; flex-direction: column; gap: 3px; }
.msg-day { align-self: center; font-size: 12px; color: var(--text-faint); background: var(--glass); border: 1px solid var(--border); padding: 4px 12px; border-radius: 99px; margin: 12px 0; text-transform: capitalize; }

/* ── Bulles ── */
.msg-wrap { position: relative; display: flex; flex-direction: column; gap: 3px; max-width: min(74%, 560px); }
.msg-wrap.mine { align-self: flex-end; align-items: flex-end; }
.msg-wrap.theirs { align-self: flex-start; align-items: flex-start; }
.bubble { display: flex; max-width: 100%; }

/* Barre d'actions au survol (réagir / modifier / supprimer) */
.msg-actions { position: absolute; top: -15px; display: flex; gap: 3px; padding: 3px; border-radius: 99px;
  background: var(--glass-strong); border: 1px solid var(--border); box-shadow: var(--shadow-sm);
  -webkit-backdrop-filter: blur(18px) saturate(180%); backdrop-filter: blur(18px) saturate(180%);
  opacity: 0; pointer-events: none; transition: opacity .15s; z-index: 3; }
.msg-wrap.mine .msg-actions { right: 4px; } .msg-wrap.theirs .msg-actions { left: 4px; }
.msg-wrap:hover .msg-actions { opacity: 1; pointer-events: auto; }
.msg-act { width: 28px; height: 28px; border: none; background: transparent; border-radius: 50%; cursor: pointer;
  color: var(--text-dim); display: grid; place-items: center; }
.msg-act:hover { background: var(--glass-hover); color: var(--text); }
.msg-act.danger:hover { color: #ff6b6b; }

/* Chips de réaction sous la bulle */
.reactions { display: flex; flex-wrap: wrap; gap: 4px; }
.reactions:empty { display: none; }
.reaction-chip { border: 1px solid var(--border); background: var(--glass); border-radius: 99px; padding: 1px 8px;
  font-size: 13px; cursor: pointer; line-height: 1.5; }
.reaction-chip:hover { background: var(--glass-hover); }
.reaction-chip.mine { background: var(--coral-soft); border-color: rgba(239,121,91,.4); color: var(--coral); }

/* Sélecteur d'emoji (réaction) */
.react-pop { position: fixed; z-index: 400; display: flex; gap: 2px; padding: 6px; border-radius: 99px;
  background: var(--glass-strong); border: 1px solid var(--border); box-shadow: var(--shadow);
  -webkit-backdrop-filter: blur(24px) saturate(180%); backdrop-filter: blur(24px) saturate(180%); animation: pop .16s var(--ease); }
.react-emoji { width: 38px; height: 38px; border: none; background: transparent; border-radius: 50%; font-size: 21px; cursor: pointer; transition: transform .1s, background .15s; }
.react-emoji:hover { background: var(--glass-hover); transform: scale(1.15); }
.react-emoji.on { background: var(--coral-soft); }
.bubble-body { padding: 9px 13px 7px; border-radius: 20px; position: relative; line-height: 1.4; font-size: 15px; word-break: break-word; }
.bubble.theirs .bubble-body { background: var(--glass-strong); border: 1px solid var(--border); border-bottom-left-radius: 7px; }
.bubble.mine .bubble-body { background: linear-gradient(180deg, var(--coral), var(--coral-600)); color: #fff; border-bottom-right-radius: 7px; }
.bubble.photo.has-img .bubble-body { padding: 5px 5px 6px; }
.bubble-text { white-space: pre-wrap; }
.bubble-img { max-width: 260px; max-height: 340px; border-radius: 15px; display: block; cursor: pointer; object-fit: cover; }
.bubble-cap { padding: 6px 8px 2px; font-size: 14px; }
.bubble-meta { display: flex; align-items: center; gap: 6px; justify-content: flex-end; margin-top: 4px; }
.bubble-time { font-size: 11px; opacity: .65; white-space: nowrap; }
.bubble-edited { font-size: 11px; opacity: .65; cursor: pointer; text-decoration: underline; }
/* l'horodatage est TOUJOURS sous le contenu (jamais superposé au texte/photo) */
.bubble.photo.has-img .bubble-meta { padding: 4px 8px 2px; }
.bubble.deleted .bubble-body { background: var(--glass) !important; border: 1px dashed var(--border) !important; color: var(--text-dim) !important; }
.deleted-text { font-style: italic; opacity: .8; }

/* flèches d'accusé : envoyé → reçu → lu (couleur) */
.ticks { display: inline-flex; line-height: 0; }
.ticks.sent { color: rgba(255,255,255,.55); }
.ticks.delivered { color: rgba(255,255,255,.85); }
.ticks.read { color: #5cf08f; }
.bubble.theirs .ticks { display: none; }

.msg-readline { align-self: flex-end; font-size: 11.5px; color: var(--text-faint); margin: 1px 2px 6px; }

/* photos éphémères */
.eph { display: flex; align-items: center; gap: 8px; padding: 6px 6px; font-size: 14px; font-weight: 540; }
.eph.view { cursor: pointer; color: #fff; }
.eph.view:hover { opacity: .9; }
.eph.opened { opacity: .7; font-style: italic; }
.eph.sent { opacity: .85; }
.bubble.theirs .eph.view { color: var(--coral); }

/* ── Composeur ── */
.msg-composer { display: flex; align-items: flex-end; gap: 8px; padding: 12px 16px; border-top: 1px solid var(--hairline); }
.msg-snap { color: var(--coral); }
.msg-input-wrap { flex: 1; background: var(--glass); border: 1px solid var(--border); border-radius: 22px; padding: 6px 14px; display: flex; }
.msg-input { width: 100%; border: none; outline: none; background: transparent; color: var(--text); font: inherit; font-size: 15px; resize: none; max-height: 120px; line-height: 1.4; }
.msg-input::placeholder { color: var(--text-faint); }

/* ── Visionneuse plein écran ── */
.img-overlay { position: fixed; inset: 0; z-index: 500; background: rgba(0,0,0,.92); display: grid; place-items: center; cursor: pointer; animation: fadeIn .2s var(--ease); }
.img-overlay img { max-width: 94vw; max-height: 86vh; border-radius: 10px; }
.img-overlay.eph img { filter: none; }
.img-hint { position: fixed; bottom: 26px; left: 0; right: 0; text-align: center; color: rgba(255,255,255,.85); font-size: 14px; }

/* ── Historique des versions ── */
.ver-item { background: var(--glass); border: 1px solid var(--border); border-radius: 12px; padding: 10px 12px; }
.ver-item.current { border-color: var(--coral); }
.ver-time { font-size: 12px; color: var(--text-faint); margin-bottom: 5px; }
.ver-body { font-size: 14px; white-space: pre-wrap; word-break: break-word; }

/* ── Caméra plein écran (photo éphémère) ── */
.cam-overlay { position: fixed; inset: 0; z-index: 600; background: #000; display: flex; }
.cam-overlay video { width: 100%; height: 100%; object-fit: cover; }
.cam-top { position: absolute; top: calc(16px + env(safe-area-inset-top)); right: 16px; z-index: 2; }
.cam-bar { position: absolute; left: 0; right: 0; bottom: calc(30px + env(safe-area-inset-bottom)); display: flex; align-items: center; justify-content: center; gap: 38px; }
.cam-shutter { width: 74px; height: 74px; border-radius: 50%; border: 5px solid #fff; background: rgba(255,255,255,.25); cursor: pointer; transition: transform .12s; }
.cam-shutter:active { transform: scale(.92); }
.cam-btn { width: 46px; height: 46px; border-radius: 50%; border: none; background: rgba(255,255,255,.18); color: #fff; cursor: pointer; display: grid; place-items: center; }
.cam-btn:hover { background: rgba(255,255,255,.3); }

/* ── Responsive : une seule colonne sur mobile/PWA ── */
@media (max-width: 820px) {
  .messenger { grid-template-columns: 1fr; }
  .msg-thread { display: none; }
  .messenger.showing-thread .msg-list { display: none; }
  .messenger.showing-thread .msg-thread { display: flex; }
  .msg-back { display: inline-flex; }
  .msg-wrap { max-width: 86%; }
}
